import {getMyData} from "./authReducer";

const MENU_EDIT = "MENU_EDIT";
const IS_START_APP = "app/IS_START_APP";
const THEME_IS_DARK = "app/THEME_IS_DARK";
const initialState = {
    isMenuOpen: false,
    isStartApp: false,
    themeIsDark: false
};

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case MENU_EDIT:
            return {
                ...state,
                isMenuOpen: action.isMenuOpen
            };
        case IS_START_APP:
            return {
                ...state,
                isStartApp: action.isStartApp
            };
        case THEME_IS_DARK:
            return {
                ...state,
                themeIsDark: action.themeIsDark
            };
        default:
            return state;
    }
};

export const editMenu = (isMenuOpen) => ({type: MENU_EDIT, isMenuOpen});
export const startAppSuccess = (isStartApp) => ({type: IS_START_APP, isStartApp});
export const setThemeIsDark = (themeIsDark) => ({type: THEME_IS_DARK, themeIsDark});


export const startApp = () => (dispatch) => {
    dispatch(getMyData()).then(() => {
        dispatch(startAppSuccess(true))
    })
};


export default appReducer